import React, {useEffect} from 'react';
import { withStyles } from "@material-ui/core/styles";
import __ from "lodash";
import PropTypes from 'prop-types';
import { FixedSizeList } from 'react-window';
import { useQueryClient } from 'react-query';

import {Checkbox, ListItem, ListItemText} from "@material-ui/core";

import { useAircraft } from "../../../services/aircraft";
import {
  useAddPermitAircraft,
  useDeletePermitAircraft,
  usePermitAircraft
} from "../../../services/permits";

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  root: {
    width: '50%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

const AircraftListLookup = props => {
  const width = props.width || 200;
  const permitUuid = props.permitUuid;
  const canEdit = props.canEdit;
  const standAloneMode = !permitUuid;
  const tailList = props.tailList ? props.tailList.replace(" ", "") : "";

  const handleAddPermitAircraft = useAddPermitAircraft();
  const handleDeletePermitAircraft = useDeletePermitAircraft();

  const queryClient = useQueryClient();
  const extraKeys = standAloneMode?["active"]:["active", "permitsRequired"];
  const records = useAircraft({queryClient, useCache: true, extraKeys});
  const permitAircraft = usePermitAircraft({ queryClient, extraKeys: [permitUuid]});

  const initializeChecked = () => {
    if (standAloneMode) {
      if (tailList !== "")
        return tailList.split(",");
      else if (props.allChecked !== false && records && records.data) {
        const allChecked = [];
        records.data.forEach(aircraft => {
          allChecked.push(aircraft.aircraftTailNumber);
        })
        let newTailList = allChecked.join(',');
        if (props.onChange) setTimeout(()=>{props.onChange(newTailList)},100);
        return allChecked;
      }
    }
    if (permitUuid &&permitAircraft && permitAircraft.data) {
      const newChecked = [];
      permitAircraft.data.forEach(aircraft => {
          newChecked.push(aircraft.aircraftTailNumber);
      })
      return newChecked;
    }
    return [];
  }

  const [checked, setChecked] = React.useState(null);

  if ((!standAloneMode || records.data) && checked === null) {
    setChecked(initializeChecked());
  }  

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    const extraKeys = [permitUuid];

    if (!standAloneMode) {
      if (currentIndex === -1) {
        newChecked.push(value);
        const newData = {permitUuid, aircraftTailNumber: value};
        handleAddPermitAircraft.mutate({record: newData, extraKeys});
      } else {
        newChecked.splice(currentIndex, 1);
        const oldData = __.find(permitAircraft.data, {aircraftTailNumber: value});
        handleDeletePermitAircraft.mutate({oldRecord: oldData, extraKeys})
      }
    } else {
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      let newTailList = "";
      newChecked.forEach((item, i) => {
        newTailList = newTailList + (i > 0 ? "," : "") + item;
      })

      if (props.onChange)
        props.onChange(newTailList);
    }

    setChecked(newChecked);
  };

  const renderRow = (props) => {
    const {index, style, isScrolling} = props;

    // if (isScrolling)
    //   return (<div style={{minHeight:50}}>&nbsp;</div>);

    const record = records.data[index];
    const labelId = `checkbox-list-label-${record.aircraftTailNumber}`;

    return (
      <ListItem key={record.aircraftTailNumber} style={style} dense disablePadding button disabled={!canEdit} onClick={handleToggle(record.aircraftTailNumber)}>
        {/* <ListItemIcon> */}
          <Checkbox
            style={{padding:3}}
            edge="start"
            checked={checked && checked.indexOf(record.aircraftTailNumber) !== -1}
            tabIndex={-1}
            disableRipple
            inputProps={{ 'aria-labelledby': labelId }}
            color={standAloneMode ? 'primary' : undefined}
          />
        {/* </ListItemIcon> */}
        <ListItemText id={labelId} primary={record.aircraftTailNumber} />
      </ListItem>
    );
  }

  renderRow.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  return (
    records.data
      ?
        <FixedSizeList height={400} width={width} itemSize={38} itemCount={records.data.length} useIsScrolling>
          {renderRow}
        </FixedSizeList>
      :
        <></>
  );

}

export default withStyles(styles) (AircraftListLookup);
